export const conversationsConstants = {
  CONNECTION: 'CONNECTION',
  SET_SOCKET: 'SET_SOCKET',
  CONVERSATIONS: 'CONVERSATIONS',
  CLEAR: 'CLEAR',
  SET_MESSAGES: 'SET_MESSAGES',
  SET_CONVERSATION: 'SET_CONVERSATION',
  SET_POST: 'SET_POST',
  SET_POSTS: 'SET_POSTS',
  SET_REPLIES: 'SET_REPLIES',
  GLOBALCOUNT: 'GLOBALCOUNT',
  ACTIVETAB: 'ACTIVETAB',
  SET_PRE_POPULATED_MESSAGE: 'SET_PRE_POPULATED_MESSAGE',
  SET_PINNED_MESSAGES: 'SET_PINNED_MESSAGES',
  SET_LATEST_PINNED_MESSAGE: 'SET_LATEST_PINNED_MESSAGE',
  UPDATE_MESSAGE_PINNED_STATUS: 'UPDATE_MESSAGE_PINNED_STATUS',
};
